import Vue from 'vue';
import Router from 'vue-router';

// 首页
import home from '@/views/home/home.vue';
// 线路查询
import qroute from '@/views/qroute/qroute.vue';
// 线路查询结果
import qrouteResult from '@/views/qroute/result.vue';
// 线路详情
import info from '@/views/info/info.vue';
// 线路详情
import map from '@/views/map/map.vue';
// 乘车查询
import query from '@/views/query/query.vue';
// 乘车详情
import queryResult from '@/views/query/result.vue';
// 站点查询
import qsite from '@/views/qsite/qsite.vue';
// 站点线路
import qsiteResult from '@/views/qsite/result.vue';
// 意见反馈
import suggestion from '@/views/suggestion/suggestion.vue';
// 大道掌上公交
import error from '@/views/error/error.vue';

Vue.use(Router);
const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        title: '大道掌上公交'
      }
    },
    {
      path: '/qroute',
      name: 'qroute',
      component: qroute,
      meta: {
        title: '线路查询'
      }
    },
    {
      path: '/qrouteResult',
      name: 'qrouteResult',
      component: qrouteResult,
      meta: {
        title: '线路查询结果'
      }
    },
    {
      path: '/info',
      name: 'info',
      component: info,
      meta: {
        title: '线路详情'
      }
    },
    {
      path: '/map',
      name: 'map',
      component: map,
      meta: {
        title: '线路详情'
      }
    },
    {
      path: '/query',
      name: 'query',
      component: query,
      meta: {
        title: '乘车查询'
      }
    },
    {
      path: '/queryResult',
      name: 'queryResult',
      component: queryResult,
      meta: {
        title: '乘车详情'
      }
    },
    {
      path: '/qsite',
      name: 'qsite',
      component: qsite,
      meta: {
        title: '站点查询'
      }
    },
    {
      path: '/qsiteResult',
      name: 'qsiteResult',
      component: qsiteResult,
      meta: {
        title: '站点线路'
      }
    },
    {
      path: '/suggestion',
      name: 'suggestion',
      component: suggestion,
      meta: {
        title: '意见反馈'
      }
    },
    {
      path: '/error',
      name: 'error',
      component: error,
      meta: {
        title: '大道掌上公交'
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;
